import React, { useRef, useEffect, useState } from 'react';
import {PHOTO_BASE_URL_Admin } from '../../Api/config';
import apiClient from '../../Api/apiClient';
const TenderPublishDetails = () => {
    const sliderRef = useRef(null);
    const intervalRef = useRef(null);
    const [PDFs, setPDFs] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
   useEffect(() => {
     // Fetch client data
     const fetchClients = async () => {
       try {
         const response = await apiClient.get(
           '/user/visitor/sample-pdf'
         );
         console.log('Sample PDF:', response.data.data);
         setPDFs(response.data.data || []);
       } catch (err) {
         setError('Error fetching client data.');
         console.error(err);
       } finally {
         setLoading(false);
       }
     };

     fetchClients();
   }, []);
  
  
    useEffect(() => {
      if (PDFs.length > 0) {
        // Auto-slide functionality after clients are loaded
        const startAutoSlide = () => {
          intervalRef.current = setInterval(() => {
            setActiveIndex(prevIndex => (prevIndex + 1) % PDFs.length);
          }, 5000); // Slide every 5 seconds
        };

        startAutoSlide();

        return () => {
          if (intervalRef.current) clearInterval(intervalRef.current);
        };
      }
    }, [PDFs]);
  
    useEffect(() => {
      if (sliderRef.current) {
        const containerWidth = sliderRef.current.offsetWidth;
        sliderRef.current.scrollTo({
          left: containerWidth * activeIndex,
          behavior: 'smooth',
        });
      }
    }, [activeIndex]);
  
    const handleScroll = direction => {
      setActiveIndex(prevIndex => {
        if (direction === 'left') {
          return prevIndex === 0 ? PDFs.length - 1 : prevIndex - 1;
        }
        return (prevIndex + 1) % PDFs.length;
      });
  
      // Pause and restart auto-slide
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setTimeout(() => {
          const startAutoSlide = () => {
            intervalRef.current = setInterval(() => {
              setActiveIndex(prevIndex => (prevIndex + 1) % PDFs.length);
            }, 5000);
          };
          startAutoSlide();
        }, 5000);
      }
    };
  
    const handleDotClick = index => setActiveIndex(index);
  
  if (loading) return <div className="text-center">Loading...</div>;
  if (error) return <div className="text-center text-red-500">{error}</div>;
  
  return (
    <div className="md:px-0 py-4 px-2 mx-auto container  md:mt-0 mt-0">
      {/* Main Layout */}
      <h1 className="mb-6 font-bold text-dark-blue md:text-center md:text-xl text-lg">
        Read details before your tender publish request
      </h1>
      <div className="flex flex-col md:flex-row gap-12">
        {/* Left Column */}
        <div className="md:w-2/3 w-full">
          <h2 className="text-lg md:text-xl font-bold text-gray-800 mb-4">
            Details
          </h2>
          <p className="text-gray-700 text-sm md:text-base mb-4">
            Post your Tender or Auction Notice on TenderWise easily. You can
            post your own tender or auction notice on TenderWise for
            procurement. It’s simple and low-cost, helping you buy good quality
            items at a great price. Over the last 12 years, nearly 20,000
            tenders and bidders have registered with TenderWise. Your tender or
            auction notice will reach all those potential bidders and bidders
            quickly.
          </p>
          <p className="text-gray-700 text-sm md:text-base mb-4">
            This is an effective way to simplify procurement tasks. Posting on
            TenderWise is faster and more cost-effective compared to publishing
            ads in newspapers. Many international donor organizations, NGOs, and
            private companies such as UCORP, Save the Children, Plan Pacific
            Sangoran, and the Indian High Commission regularly publish their
            tender or auction notices on this site.
          </p>
          <p className="text-sm md:text-base text-gray-700 font-semibold">
            Service Fee: The fee for publishing one A4-sized notice is 1,000
            BDT.
          </p>
        </div>

        {/* Right Column */}
        <div>
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-4">
              Purpose of Posting Tender or Auction Notices:
            </h3>
            <ul className="list-disc list-inside text-gray-700 mb-6">
              <li>
                To select the best supplier and purchase goods, works, or
                services at competitive prices—ensuring quality at the best
                price.
              </li>
              <li>To ensure wide promotion of the notice.</li>
              <li>To reduce costs compared to newspaper advertisements.</li>
              <li>
                To facilitate participation by many local and international
                bidders.
              </li>
              <li>
                To post RFQ (Request for Quotation), private tenders, and
                limited tender notices.
              </li>
            </ul>

            <h3 className="text-lg md:text-xl font-semibold text-gray-800 mb-4">
              Rules for Publishing Tender or Auction Notices:
            </h3>
            <ul className="list-disc list-inside text-gray-700">
              <li>
                Write the tender or auction notice on your company letterhead
                following the format provided and seal/sign it, then upload it
                using the provided links.
              </li>
              <li>
                Once the notice is published, TenderWise will notify you via
                email. It will also be visible on your dashboard.
              </li>
              <li>
                The notice will remain published on the TenderWise portal for
                its validity period.
              </li>
              <li>
                If a revised notice is submitted, it will be linked with both
                the original and revised notices.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-8 bg-samplePdfBGColor bg-opacity-15 rounded-md">
        <h2 className="text-lg md:text-xl text-center  font-bold text-gray-800 mb-4 p-4 border-b">
          Sample PDF Format
        </h2>
        <div className="relative overflow-hidden">
          <div
            ref={sliderRef}
            className="flex overflow-hidden snap-x snap-mandatory"
            style={{
              scrollBehavior: 'smooth',
              scrollbarWidth: 'none', // Firefox
            }}
          >
            {PDFs.map((pdf, index) => (
              <div
                key={pdf.id}
                className="snap-center flex-shrink-0 w-full md:w-1/3 p-4"
              >
                <h3 className="text-sm font-semibold text-gray-800 p-2">
                  {pdf.name}
                </h3>
                <div className="bg-white shadow-lg border rounded-lg p-4 text-center py-4">
                  <div className="flex justify-center mb-4">
                    <img
                      src={`${PHOTO_BASE_URL_Admin}${pdf.tender_pdf}`}
                      alt={pdf.name}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Dots Navigation */}
      <div className="flex justify-center mt-4">
        {PDFs.map((_, index) => (
          <button
            key={index}
            className={`w-3 h-3 rounded-full mx-1 ${
              index === activeIndex ? 'bg-gray-800' : 'bg-gray-400'
            }`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default TenderPublishDetails;
